export enum TenantContactTypeEnum {
	AGENT = 'agent',
	LOCATION = 'location',
	CUSTOMER = 'customer',
	SUPPLIER = 'supplier',
	VEHICLE_DAMAGE = 'vehicle_damage',
}
